import * as angular from "angular";
import * as _ from "lodash";
import {$agentFactory} from "../../agents/$agent.factory";
import {IRootScopeService} from "angular";

export class AgentMarkerService {
  constructor(private $rootScope: IRootScopeService, private $agent: $agentFactory, private $task, private mapConstant) {
  }

  panToAgent(markers, id, map) {
    markers.forEach((marker) => {
      if (marker.id === id) {
        if (map)
          map.panTo(marker.position);
      }
    });
  }

  clearAll(markers) {
    markers.forEach((marker) => {
      marker.setMap(null);
    });
  }

  getCourierMarkerIcon(hover) {
    const height = 50;
    const width = 50;
    const index = 1;

    return {
      url: 'assets/images/map/driver_markers_vr2.png',
      content: '<div class="dot"> <div class="centraldot"></div><div class="wave"></div><div class="wave2"></div></div>',
      scaledSize: new google.maps.Size(width * 2, height),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(25, 40),
      zIndex: google.maps.Marker.MAX_ZINDEX,
      origin: new google.maps.Point(index * width, 0)
    };
  }

  courierToMarker(map, courier, show) {
    const location = _.get(courier, 'location.location');

    if (!location) {
      return;
    }

    const marker = new google.maps.Marker({
      map: show ? map : null,
      icon: this.getCourierMarkerIcon(false),
      position: location,
      zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX)
    });
    marker.set("id", courier.id);

    return marker;
  }

  idsToMarkers(map, ids, show, dontRegister) {
    let retVal = [];
    ids.forEach((agentId) => {
      const marker = this.courierToMarker(map, this.$agent(agentId).$value(), show);
      if (!marker) {
        return;
      }
      retVal.push(marker);
      if (!dontRegister) {
        this.registerAgentMarkerEvents(marker);
      }
    });

    return retVal;
  }

  registerAgentMarkerEvents(marker) {
    marker.addListener('click', () => {
      const agent = this.$agent(marker.id).$value();
      const allStops = [{
        type: 'agent',
        id: marker.id
      }];
      this.$rootScope.$emit('scroll-to-agent', marker.id);
      if (agent.itineraryInfo.numberOfTasks) {
        this.$rootScope.$broadcast(this.mapConstant.events.itinerary.draw, allStops);
        return;
      }

      agent.itineraryInfo.taskIds.forEach((sid) => {
        allStops.push({
          type: 'task',
          id: sid
        });
      });

      this.$task().$getAll({
        ids: agent.itineraryInfo.taskIds
      })
        .then(() => {
          this.$rootScope.$broadcast(this.mapConstant.events.itinerary.draw, allStops);
          this.$rootScope.$emit('scroll-to-agent', marker.id);
        });

    });
  }

}

angular
  .module('bringoz.admin.map')
  .service('agentMarkersService', AgentMarkerService);
